(() => {
  const overlay = qs('.js-mobile-overlay');
  const accordionTrigger = qsa('.js-filter__content-heading');
  const accordionContent = qsa('.js-content-accordion');
  const drawerTrigger = qs('.js-filter-mobile');
  const visibleOverlay = 'filter__mobile-overlay--visible';
  const accordionOpen = 'filter__content-list--open';
  const drawerActive = 'filter--open';
  const drawer = qs('.js-filter');
  const mobile = window.matchMedia('(max-width: 989px)');
  const closeDrawer = qsa('.js-filter-close, .js-mobile-overlay');
  const activeFilters = qsa('.js-filter__active-item');
  const clearAllButton = qs('.js-filter__clear-all');
  const filterHeaders = qsa('.js-filter__content-heading');
  const clearAllFilterTags = qsa('.js-filter__active-item--clear-all');
  
  
  function openDrawerFilter() {
    
      console.log('openDrawerFilter');
      filterHeaders.forEach((el, index) => {
        if (index === 0) {
          el.closest('.js-filter__content-item').querySelector('.js-content-accordion').style.display = 'block';
          return;         
        }

        el.classList.remove('filter__content-list--open');
        el.closest('.js-filter__content-item').querySelector('.js-content-accordion').style.display = 'none';
      });
  }
  
  drawerTrigger.addEventListener('click', () => {
    openDrawerFilter();
    if (mobile.matches) { 
      drawer.classList.add(drawerActive);
      overlay.classList.add(visibleOverlay);
      scrollLock();
      filterHeaders.forEach((el, index) => {
        if (index === 0) {
          el.closest('.js-filter__content-item').querySelector('.js-content-accordion').style.display = 'block';
          return;         
        }

        el.classList.remove('filter__content-list--open');
      });
    } 
  });
  
  closeDrawer.forEach((el)=> {
    el.addEventListener('click', () => {
      if (mobile.matches) {
        drawer.classList.remove(drawerActive);
        overlay.classList.remove(visibleOverlay);
        scrollLock(false);
      }
    })
  })
  
  accordionTrigger.forEach((item) => {
    item.addEventListener('click', (e) => {
      const parent = e.currentTarget.closest('.js-filter__content-item');
      const content = parent.querySelector('.js-content-accordion')
      if (e.currentTarget.classList.contains(accordionOpen)) {
        e.currentTarget.classList.remove(accordionOpen)
        content.style.display = 'none';
      } else {         
        e.currentTarget.classList.add(accordionOpen);
        content.style.display = 'block';
      }
    });
  
    mobile.addEventListener('change', () => {
      if (!mobile.matches) {
        item.classList.remove(accordionOpen);
        accordionContent.forEach((el) => {
          el.removeAttribute('style');
        });
      }
    });
  });

  if (activeFilters.length) {
    clearAllButton.removeAttribute('disabled');
    clearAllFilterTags.forEach((el) => {
      el.style.display = 'inline-block';
    });
  } else {
    clearAllFilterTags.forEach((el) => {
      el.remove();
    });
  }
  
  let displayValOne = qs('.js-filter-price-range-value-left');
  let displayValTwo = qs('.js-filter-price-range-value-right');
  let minGap = 10;
  let sliderTrack = qs('.js-filter-price-range-slider-track');
  let sliderMaxValue = 0;
  const rangeLeft = qs('.js-filter-price-range-left');
  const rangeRight = qs('.js-filter-price-range-right');

  if (document.getElementById("slider-1")) {
    sliderMaxValue = document.getElementById("slider-1").max;
  }
  
  function fillColor() {
    percent1 = (rangeLeft.value / sliderMaxValue) * 100;
    percent2 = (rangeRight.value / sliderMaxValue) * 100;
    sliderTrack.style.background = `linear-gradient(to right, #dadae5 ${percent1}% , #000 ${percent1}% , #000 ${percent2}%, #dadae5 ${percent2}%)`;
  }
  
  function slideOne() {
    if(parseInt(rangeRight.value) - parseInt(rangeLeft.value) <= minGap){
      rangeLeft.value = parseInt(rangeRight.value) - minGap;
    }
    displayValOne.textContent = rangeLeft.value;
    fillColor();
  }
  
  function sliderTwo() {
    if(parseInt(rangeRight.value) - parseInt(rangeLeft.value) <= minGap){
      rangeRight.value = parseInt(rangeLeft.value) + minGap;
    }
    displayValTwo.textContent = rangeRight.value;
    fillColor();
  }
  
  if (rangeLeft & rangeRight) {
    sliderMaxValue = document.getElementById("slider-1").max;

    rangeLeft.addEventListener("input", () => {
      slideOne();
    });
    
    rangeRight.addEventListener("input", () => {
      sliderTwo();
    });
    
    sliderTwo();
    slideOne();
  }
  openDrawerFilter();
  })();
